import { Box, Button, Grid2, } from '@mui/material'
import { CustomIconButton } from '../../shared/utils/IconButton'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Form_Padding } from '../../shared/constants';
import { Formik, Field, Form } from "formik";
import * as yup from "yup";
import { isValidPhoneNumber } from 'react-phone-number-input';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { PhoneInputFormField } from '../../shared/components/formfields/PhoneInputFormField';
import useAuthStore from '../../store/useAuthStore';
import { LocationSelectorField } from '../../shared/components/LocationSelectorField';
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi';
import { DropzoneUploadFormField } from '../../shared/components/formfields/DropzoneUploadFormField';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToaster } from '../../shared/utils/ToasterProvider';
import api from '../../assets/nodeApi/axiosInstance';

const TrainerForm = ({ onClose }) => {
    const { showToaster } = useToaster();
    const { token } = useAuthStore();
    const { data: userDetail } = useGetUserDetail()
    const queryClient = useQueryClient();

    const initialValues = {
        profile_image: userDetail?.data?.profile_image || "",
        country_name: userDetail?.data?.country_name || "",
        state: userDetail?.data?.state || "",
        city: userDetail?.data?.city || "",
        firstname: userDetail?.data?.firstname || "",
        lastname: userDetail?.data?.lastname || "",
        email: userDetail?.data?.email || "",
        mobile: userDetail?.data?.mobile || "",

    };

    const updateMutation = useMutation({
        mutationFn: (formData) => api.put("/user/update/profile", formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
            },
        }),
    });

    const handleSubmit = (values) => {
        console.log(values)
        const formData = new FormData();
        if (values.profile_image) {
            formData.append('profile_image', values.profile_image);
        }
        formData.append('lastname', values?.lastname);
        formData.append('country_name', values?.country_name);
        formData.append('state', values?.state);
        formData.append('city', values?.city);
        formData.append('email', values?.email);
        formData.append('mobile', values?.mobile);
        formData.append('firstname', values?.firstname);
        updateMutation.mutate(formData, {
            onSuccess: () => {
                showToaster('Profile Update Successfullly', '', 'success')
                queryClient.invalidateQueries({ queryKey: ["user/details"] });
                if (onClose) onClose();
            },
            onError: (error) => {
                showToaster(error?.data?.error || 'Something went wrong', '', 'error')
            }
        });

    }

    return (
        <Box >
            <Box sx={{ p: Form_Padding, bgcolor: "blue.main", position: "relative", minBlockSize: "50px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <CustomIconButton icon={<KeyboardBackspaceIcon style={{ color: "#fff" }} fontSize='26px' />} onClick={onClose} />
                </Box>
            </Box>
            <Box sx={{ p: Form_Padding, mt: "40px" }}>


                <Formik initialValues={initialValues} enableReinitialize={true} onSubmit={handleSubmit}>
                    {() => (
                        <Form>

                            <Grid2 container spacing={3} >
                                <Grid2 children size={{ xs: 12 }}>
                                    <Field
                                        name="profile_image"
                                        component={DropzoneUploadFormField}
                                        label="Trainer Photo"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="firstname"
                                        component={TextFormField}
                                        label="Trainer Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="lastname"
                                        component={TextFormField}
                                        label="Last Name"
                                        isRequired={false}
                                    />
                                </Grid2>
                                <LocationSelectorField
                                    countryField="country_name"
                                    stateField="state"
                                    cityField="city"
                                    isStoredId={false}
                                    isPincode={false}
                                    Input_Width={{ xs: 12, sm: 6 }}
                                    userDetail={userDetail?.data}
                                    passedCityId={userDetail?.data?.city_id}
                                    passedStateId={userDetail?.data?.state_id}
                                    passedCountryId={userDetail?.data?.country_id}
                                />

                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="mobile"
                                        component={PhoneInputFormField}
                                        label="Mobile Number"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Field
                                        name="email"
                                        component={TextFormField}
                                        label="E-mail Id "
                                        isRequired={true}
                                    />
                                </Grid2>

                                <Grid2 children size={{ sm: 6, xs: 12 }} />
                                <Grid2 children size={{ sm: 6, xs: 12 }}>
                                    <Button variant="contained" fullWidth type="submit">save </Button>
                                </Grid2>

                            </Grid2>

                        </Form>
                    )}
                </Formik>
            </Box>
        </Box>
    )
}

export default TrainerForm

